
import { Component, ElementRef, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import * as moment from 'moment'
import { NbDateService, NbDialogService, NbStepComponent, NbStepperComponent } from '@nebular/theme';
import { v4 as uuidv4 } from 'uuid';

import {
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
  startOfHour,
  differenceInMinutes,
} from 'date-fns';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';

import { DatePipe } from '@angular/common';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

import { CalendarDateFormatter } from 'angular-calendar';
import { CalendarEventTitleFormatter } from 'angular-calendar';

import {
  ChangeDetectorRef,
  Injectable,
  ViewEncapsulation,
} from '@angular/core';
import { WeekViewHourSegment } from 'calendar-utils';
import { fromEvent } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { addMinutes, endOfWeek } from 'date-fns';
import { Physician, PhysicianData } from '../../../@core/interfaces/masters/physician-mst';
import { Department, DepartmentData } from '../../../@core/interfaces/masters/department';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PatientAppointment, PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { formatDate } from '@angular/common';
import * as communication from './../../../data/auto-communication.json';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { TenantBranchData } from '../../../@core/interfaces/masters/tenantbranch';
import { CalendarWeekViewComponent } from 'angular-calendar';
import { Location } from '@angular/common';
import * as gender from './../../../data/gender.json';

import { MouseEvent } from '@agm/core';
import { HttpHeaders } from '@angular/common/http';
import { ChiefComplaintsData } from '../../../@core/interfaces/masters/chiefcomplaint';
import * as title from './../../../data/title.json';

import * as sha512 from 'js-sha512';
import { CookieService } from '../../../@theme/components/common/service/cookies.service';

// import {OnlinePaymentData,OnlinePayment} from '../../../@core/interfaces/patient-services/online-payment';
import { environment } from '../../../../environments/environment';
import { PatientRegistration, PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { CollectionReportData } from '../../../@core/interfaces/report/collectionReport';
import { INgxSelectOption } from 'ngx-select-ex';

function floorToNearest(amount: number, precision: number) {
  return Math.floor(amount / precision) * precision;
}

function ceilToNearest(amount: number, precision: number) {
  return Math.ceil(amount / precision) * precision;
}

@Component({
  selector: 'ngx-patient-login',
  templateUrl: './patient-login.component.html',
  styleUrls: ['./patient-login.component.scss']
})
export class PatientLoginComponent implements OnInit,OnDestroy {


  protected readonly unsubscribe$ = new Subject<void>();
  patient_details: any;
  patient_landing: any = false;
  p: number = 1;
  p1: number = 1
  p2: number = 1
  p3: number = 1
  pp: number = 1;

  @ViewChild('stepper') stepperComInst: NbStepperComponent;
  @ViewChild('patientDetails') patientComInst: NbStepComponent;
  @ViewChild('paymentDetails') paymentComInst: NbStepComponent;
  smsdto={"variables":[],"template_id":"","to":"","service":"T"};
  openAppointmentPage:boolean=false;
  skip: any = 0;
  take: any = 100;
  paient_reg_id: any;
  isShowdialog: boolean = false;
  newUserPage: boolean = false;
  existinguserPage: boolean = false;

  @ViewChild('modalContent') contentTemplate: TemplateRef<any>;
  // @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLElement>;
  newAppoinment: any;
  view: CalendarView = CalendarView.Week;
  dragToCreateActive = false;
  weekStartsOn: 0 = 0;
  CalendarView = CalendarView;
  // events = [];
  viewDate: Date = addDays(new Date(), 4);

  clickedDate: Date;
  otpSentToCustomer:boolean=false;
  registrationClickCount:number=0;
  appointmentBookingClickCount:number=0;
  registerNewPatientClickSubmitted:boolean=false;
  clickedColumn: number;
  phyList: Physician[];
  loadPhyList: Physician[];
  deptList: Department[];
  branchData: any = [];
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  multiple: boolean = false;
  allowClear: boolean = true;
  placeholder = '';
  isSubmitted: boolean = false;
  EnterOtp:string;
  incorrectOTP:boolean=false;
  // Shown alongside incorrectOTP - lets send failures (e.g. rate limit / cooldown text from the
  // backend) and verify failures ("Incorrect OTP") both surface a real, specific message instead
  // of always showing the same hardcoded "Incorrect OTP" text.
  otpErrorMessage: string = 'Incorrect OTP';
  otpVerificationSuccess:boolean=false;
  patientFutureAppointments: any = [];
  patientPastAppointments: any = [];
  // appoiment data
  selectedVisitType: any = "Clinic";
  start = null;
  end = null;
  activeDayIsOpen: boolean = true;
  templateMasterList: Array<any> = [];
  public commList: any[] = (communication as any).default;
  searchterm: any = "";
  searchterm1: any = "";
  private tenandId = environment.dentaliaTenantId;
  private branchId = environment.dentalidBranchId;
  AptForm: FormGroup;
  chipsList: any = [];
  physicianList: any = [];
  registrationForm: FormGroup;
  otpForm:FormGroup;

  titleList: any = (title as any).default;
  genderList: string[] = (gender as any).default;
  chooseAnyOneFilter:boolean=false;
  searchExistingPatientSubmitted:boolean=false;
  // google maps zoom level
  zoom: number = 10;

  // initial center position for the map
  lat: number = 13.0826802;
  lng: number = 80.2707184;

  //Doctor Slots
  docScheData: Array<any> = [];
  docAvailsData: Array<any> = [];
  bookedApts: any[] = [];
  bookedAptDates: any = [];
  events: any = [];
  leaveEvents: any = [];
  chips: Array<{ date: Date, time: any, disabled: any, duration: number }> = [];
  tempChips: Date[] = [];
  selectedHours: number[] = [];
  addSlotHours = [];
  addSlotPopup: boolean = false;
  doctorLists = [];
  allDoctorLists = [];
  patAptDates: Array<{ date: Date, doctorId: any }>;
  dayHeaders: any = [];
  weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  min;
  todayDate;
  appoimentDetails: any;
  patientData: any;
  patientCreate: any;
  patientEdit: any;
  visitType: boolean = false;
  isDoctorSlot: boolean = false;
  isEditApt: boolean = false;
  isconfirmationMessage: boolean = false;
  doctorSlots: any;

  returnPatientName:string;
  returnPatientAge:string;
  returnPatientMobile:string;
  returnPatientAddress:string;
  returnPatientGender:string;
  returnPatientTitle:string;
  returnPatientRegNumber:string;
  returnPatientRegId:string;
  noPatientDataFoundBySearch:boolean=false;
  // payment variable
  regID = localStorage.getItem("regID");
  resurl = environment.apiUrl+"/onlinepayment/"+this.tenandId+"/"+this.branchId+"/paymentReceive";
  // http://localhost:8085/api/onlinepayment/6bced242-032d-47d6-e7cb-08d8f2bf3f35/82b28344-d04e-41a0-6465-08d8f2bf3fc3/paymentReceive
  statusUrl= window.location.href;
  url = "https://test.payu.in/_payment"
  key = "JPM7Fg"
  txnid = uuidv4();
  amount: any = 0;
  firstname = "Raja"
  email = "raja@ezovion.com"
  phone = "8778733766"
  productinfo = "Video Appointment"
  surl = this.resurl
  furl = this.resurl
  curl = this.resurl
  udf1 = this.tenandId;
  udf2 = this.branchId;
  udf3 = this.regID;
  udf4 = ""; //appointment Id
  udf5 = this.statusUrl.replace("patient-appointment","payment-status"); //apiurl
  hash = ""
  salt = "TuxqAugd";
  onlinePaystart: boolean = false;
  lastPaymentData: any = null;
  lastPayment: boolean = false;
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;

  // payment variable
//noof Days
noOfDays=4;
ChiefComplaintList:any=[];
drMultiple: boolean = true;
openOTPPage: boolean = false;
thisPatientAreadyRegistered: boolean = false;
FillMandatoryFieldsRegistration: boolean = false;
  constructor(
    public cookieService: CookieService,
    private route: ActivatedRoute,
    protected patRegSrvc: PatientRegistrationData,
    private dialogService: NbDialogService,
    private IpOpCollectionReporsrvc:CollectionReportData,
    protected phySrvc: PhysicianData,
    protected dateService: NbDateService<Date>,
    private fb: FormBuilder,
    public location: Location,
    protected chiefComplSrvc: ChiefComplaintsData,
    protected tenantBrchSrvc: TenantBranchData,
    private datePipe: DatePipe,
    protected tenantSrvc: TenantData,
    private patAptSrvc: PatientAppointmentData,
    protected deptSrvc: DepartmentData,
    // protected onlinePaymentSrvc:OnlinePaymentData,
    private cdr: ChangeDetectorRef) {
    this.AptForm = this.fb.group({
      chiefComplaintID: new FormControl(null),
      tenantId: new FormControl(environment.dentaliaTenantId, [Validators.required]),
      department: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      date: new FormControl(new Date(), [Validators.required]),
      startDate: new FormControl(new Date(), [Validators.required]),
      endDate: new FormControl(new Date(), [Validators.required]),
    });

    this.registrationForm = this.fb.group({
      title: new FormControl(null, [Validators.required]),
      firstName: new FormControl(null, [Validators.required,Validators.pattern('^[a-zA-Z ]+$')]),
      mobileNumber: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      address: new FormControl(null,[Validators.minLength(1), Validators.maxLength(150)]),
      age: new FormControl(null,[Validators.required,Validators.pattern('^[0-9]+$')]),
      gender: new FormControl(null, [Validators.required]),
      searchPatientMobile: new FormControl(null,[Validators.maxLength(10), Validators.pattern('[0-9]+'), Validators.minLength(10)]),
      searchPatientReg: new FormControl(null,[Validators.pattern('^[a-zA-Z0-9]+$'),Validators.minLength(1), Validators.maxLength(20)]),
      ageResult: new FormControl(null, [Validators.required]),

    });

    this.otpForm = this.fb.group({
      digit1: this.fb.control('',[Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
   

    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  }


  markers: marker[] = [
    {
      lat: 13.0826802,
      lng: 80.2707184,
      label: 'A',
      draggable: true
    },
    {
      lat: 14.0826802,
      lng: 83.215982,
      label: 'B',
      draggable: false
    },
    {
      lat: 11.500348971803076,
      lng: 79.69448130560768,
      label: 'C',
      draggable: true
    }
  ]


  loop: any = ["1",
    "2", "3", "4", "5", "6", "7",
  ]
  ngOnInit(): void {

    // this.checkOnliePaymentPendint();

    var date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    var time = this.datePipe.transform(new Date(), 'HH:mm');
    var date1 = date + "T" + time + ":00.000Z";

    this.paient_reg_id = window.localStorage.getItem("regID");
    this.loadPhysicianList();
    this.loadChiefComplaints();
   

    navigator.geolocation.getCurrentPosition((position) => {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
    })
    let currentDate = new Date(Date.now());
    this.todayDate = new Date(Date.now());
    this.min = this.dateService.addDay(new Date(Date.now()), 0);

  }
  ngOnDestroy(): void {

  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.patientData = JSON.parse(window.localStorage.getItem("patientData"));
    if (this.patientData != null) {
    }
    this.getTemplateId();

  }

  get registrationVal() { return this.registrationForm.controls; }


  clickedMarker(label: string, index: number) {
  }

  mapClicked($event: MouseEvent) {

    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });
  }

  markerDragEnd(m: marker, $event: MouseEvent) {
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: false
    });
  }
  viewChange: EventEmitter<string> = new EventEmitter();

  viewDateChange: EventEmitter<Date> = new EventEmitter();

  loadPhysicianList(): void {
    this.chiefComplSrvc.list("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId + '/doctorList').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.physicianList = [{ id: 'All', doctorName: 'All' }, ...data]
    }, (error) => {

    }, () => {

    });
  }
  
  drOnChange(event){

    if(event!=undefined && event.length){


if(event[0].value=="All"){
  this.AptForm.controls["department"].setValue(null)
}

    }

  }
  loadChiefComplaints(): void {
 
    this.chiefComplSrvc.list("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId + '/chiefCompMst').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      this.ChiefComplaintList = data;


    }, (error) => {

    }, () => {

    });
  }
  goPerviousDate(){
    // var date = this.dateService.addDay(this.dateService.today(), 0); 
    this.AptForm.get('date').setValue(addDays(new Date(this.AptForm.get('date').value), -this.noOfDays));
    this.loadPastAppointments();
  }
  goNextDate() {
    this.AptForm.get('date').setValue(addDays(new Date(this.AptForm.get('date').value), this.noOfDays));
    this.loadPastAppointments();
  }

  loadPastAppointments(): void {
    
    let x= this.AptForm.get('department').value.filter(e=>e=="All");
    let physicianNames=null;
    if(x.length){
      physicianNames=null;
    }else{
      physicianNames=this.AptForm.get('department').value;
    }
    var controlVal = new Date((this.AptForm.controls['date'].value));
    var endDate = addDays(controlVal, this.noOfDays);
    var dates = this.getDateArray(controlVal, endDate);
    this.dayHeaders = [...dates];
    var startDate = this.datePipe.transform(controlVal, 'yyyy-MM-dd') + " 00:00:00.000";
    var endDate_ = this.datePipe.transform(endDate, 'yyyy-MM-dd') + " 00:00:00.000";
    var data = {
      "tenantId": environment.dentaliaTenantId, //'f646ea41-0fef-4e58-fce6-08d90fb7004e',
      "doctDeptName": physicianNames,
      "apptFromDate": startDate,
      "apptToDate": endDate_,
      "location": this.AptForm.get('city').value,
      "skip": 10,
      "take": 10
    }
    

    this.patAptSrvc.searchList(`iFrameAppointmentController/`+this.tenandId+'/'+this.branchId+'/GetDoctorSlots', data).pipe(takeUntil(this.unsubscribe$)).subscribe(apts => {
      this.bookedApts = apts.appointments;
      this.docScheData = apts.schedule;
      this.docAvailsData = apts.availability;
      this.bookedAptDates = [];
      this.bookedApts.forEach(apts => {
        apts.forEach(apt => {
          if (apt.cancellationDate == null) {
            let aptdate: Date = new Date(apt.date);
            this.bookedAptDates.push({ date: this.convertToDateType(aptdate, apt.slotTime.toString()), regID: apt.regId });
          }
        });
      });
      this.getSlots(false);
    }, (error) => {

    }, () => {
    });

  }

  onYearsMonthDayChge() {   

    var birthDate = moment().subtract((this.registrationForm.get('age').value), 'years').subtract((0), 'months').subtract(0, 'days');
    

       this.registrationForm.controls["ageResult"].setValue(birthDate.format("YYYY-MM-DD"))
   

  
 } 

 bookApptOPen(){

  this.openAppointmentPage=true;
 }

  
    sendSMS(){

 
   
      let whatsappcontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is "+this.EnterOtp+". It will be valid for"+2+ " minutes only. Thanks, Ezovion."
      let smstrackingDetails={
      referencefrom:'patient-portal',
      referencenum:'5555',
      mobileNumber:"9843561297",
      dateTime:new Date(),
      message:whatsappcontent,
      smsUnit:1,
      senderId:"EZOHMS",
      status:"ok",
      templateId:"1707167284946166051",
      createdIp:null,
      createdby:parseInt(localStorage.getItem("userid")),
      createddate:new Date(),
      tenantId:'d29cc395-1670-43eb-f256-08dac9ecc7ac',
      branchId:'85307fd9-d69a-4b18-8daf-16fb57751469'  
   }
 
    let smsContent={
      text:whatsappcontent,
      mobile:"9843561297",
      apiURL:"as",
      apiKey: "facaefbd-e079-4698-a368-6d81a5a1272e",
      route:"0",
      senderId:"EZOHMS",
      tenantId:'d29cc395-1670-43eb-f256-08dac9ecc7ac',
      branchId:'85307fd9-d69a-4b18-8daf-16fb57751469',  
      smstrackingDetails:smstrackingDetails
    }
  //postapi
  this.patRegSrvc.sendMessageOtp("iFrameAppointmentController/" + "d29cc395-1670-43eb-f256-08dac9ecc7ac" +'/'+"85307fd9-d69a-4b18-8daf-16fb57751469" + '/sendSMS/'+this.registrationForm.get('mobileNumber').value+'/'+this.EnterOtp,smsContent).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      // this.resent();
   
 
    }, (err) => {
   
 
   })
 
  }

sendOtp() {

  if(this.registrationForm.get('mobileNumber').valid){
  this.smsdto.variables=[this.registrationForm.get('firstName').value,'71679650'];
  this.smsdto.template_id = "d4c2ade9-a4bf-406c-8b84-9212342c2de3";
  let data = {
    "headers": {
      "Accept": "application/vnd.ezovion.hateoas+json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    }
  }
  // SECURITY: the backend no longer returns the generated OTP. It now only confirms the OTP
  // was generated, persisted (user_otp_authentication) and dispatched via SMS. The frontend
  // never sees or stores the OTP value - see onVerifyOTP() for the server-side verify call.
  this.patRegSrvc.sendMessageOtp("patientportalnewuser/" + "d29cc395-1670-43eb-f256-08dac9ecc7ac" + '/sendotp/' + this.registrationForm.get('mobileNumber').value,data).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
    if (response && response.success) {
      // Non-secret marker only - indicates an OTP has been sent, never the OTP value itself.
      this.EnterOtp = 'sent';
      this.incorrectOTP = false;
    } else {
      this.otpErrorMessage = (response && response.message) || 'Unable to send OTP. Please try again.';
      this.incorrectOTP = true;
    }
    // Note: the previous duplicate SMS re-send via sendSMS() required the plaintext OTP on the
    // client and has been removed as part of this fix; SendSMSOTPToUser already dispatches the
    // OTP SMS server-side.
  }, (error) => {
    // Surfaces backend validation text (e.g. rate-limit/cooldown messages returned with a
    // 429) instead of a generic failure state.
    this.otpErrorMessage = (error && error.error && error.error.message) || 'Unable to send OTP. Please try again.';
    this.incorrectOTP = true;
  }, () => {


  });
  }
}

onVerifyOTP(){

  let otp = this.otpForm.get('digit1').value.toString()+this.otpForm.get('digit2').value.toString()+
  this.otpForm.get('digit3').value.toString()+this.otpForm.get('digit4').value.toString()
  +this.otpForm.get('digit5').value.toString()+this.otpForm.get('digit6').value.toString();

  // SECURITY: OTP verification happens entirely server-side. The frontend only forwards the
  // user-entered code and mobile number; it never compares against a locally-stored OTP.
  const verifyPayload = {
    otpCode: otp,
    userMobileNumber: this.registrationForm.get('mobileNumber').value
  };

  this.patRegSrvc.verifyOtp("patientportalnewuser/" + "d29cc395-1670-43eb-f256-08dac9ecc7ac" + "/verifyotp", verifyPayload).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
    if (result && result.code === 200) {
      this.otpVerificationSuccess = true;
      this.incorrectOTP = false;
      setTimeout(() => {
        this.registerPatient();
        this.newUserPage=false;
        this.isShowdialog=true;
        this.existinguserPage=false;
        this.openOTPPage=false;
      }, 1000);
    } else {
      // result.status carries the backend's specific reason (expired, incorrect, or the
      // 3-attempt lockout message) rather than a generic "Incorrect OTP" for every case.
      this.otpErrorMessage = (result && result.status) || 'Incorrect OTP';
      this.incorrectOTP = true;
    }
  }, (error) => {
    this.otpErrorMessage = (error && error.error && error.error.status) || 'Incorrect OTP';
    this.incorrectOTP = true;
  });

}




  registerPatient(){
    this.registerNewPatientClickSubmitted=true;

if(this.registrationForm.valid){
this.registrationClickCount++;
if(this.registrationClickCount==1){


  let newRegistrationData={
    "status":"OP",
    "title":this.registrationForm.get('title').value,
    "firstname":this.registrationForm.get('firstName').value,
    "mobile":this.registrationForm.get('mobileNumber').value,
    "address1":this.registrationForm.get('address').value,
    "age":this.registrationForm.get('age').value,
    "gender":this.registrationForm.get('gender').value,
    "dobFlag":"N",
    "ageResult":this.registrationForm.get('ageResult').value,
    "tenantId":environment.dentaliaTenantId,
    "branchId":environment.dentalidBranchId,
      }
    
    
      this.IpOpCollectionReporsrvc.searchList("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId+'/SavePatientregistration', newRegistrationData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if(data!=null){
          this.returnPatientName=data.firstname;
         this.returnPatientAge=data.age;
         this.returnPatientMobile=data.mobile;
         this.returnPatientAddress=data.address1;
         this.returnPatientGender=data.gender;
         this.returnPatientTitle=data.title;
         this.returnPatientRegNumber=data.regNum;
         this.returnPatientRegId=data.id;
         this.newUserPage=false;
         this.isShowdialog=true;
         this.existinguserPage=false;
    
    
    }  else{
    this.returnPatientName=null;
    this.returnPatientAge=null;
    this.returnPatientMobile=null;
    this.returnPatientAddress=null;
    this.returnPatientGender=null;
    this.returnPatientTitle=null;
    this.returnPatientRegNumber=null;
    this.returnPatientRegId=null;
    }
    
      }, (error) => {
      });
      this.EnterOtp=null;
      this.otpVerificationSuccess=false;
      this.incorrectOTP=false;
      
}


}

  }


  
  // getSlot
  getSlots(isEdit: boolean): void {
    this.doctorLists = [];
    this.events = [];
    this.leaveEvents = [];
    if (this.docScheData != null && this.docScheData != undefined && this.docScheData.length > 0) {
      this.docScheData.forEach(x1 => {
        // for(var i=start;i<this.end;i++)
        x1.forEach(x => {

          let controlVal: Date = new Date((this.AptForm.controls['date'].value as Date));
          let date: Date = new Date(controlVal.getFullYear(), controlVal.getMonth(), controlVal.getDate());
          let ispresent = this.dateService.isBetween(date, new Date(x.startDate), new Date(x.endDate));
          let sameDate = (date.getTime() === new Date(x.startDate).getTime()
            || date.getTime() === new Date(x.endDate).getTime());

          if (ispresent || sameDate) {
            //   (x.dayOfWeek.split(',')).forEach(week => {
            //  if (date.getDay() == this.weekListwithId.find(z => z.value.includes(date.getDay().toString())).id) {
            let slots = [];
            let endDate = addDays(controlVal, this.noOfDays);
            let data = {
              tenantId: x.tenantId,
              branchId: x.branchId,
              dayOfWeek: x.dayOfWeek,
              doctorId: x.physician.id,
              doctor: { name: x.physician.doctor + x.physician.displayName, id: x.physician.id, age: x.physician.age, gender: x.physician.gender, city: x.physician.city, email: x.physician.email, mobile: x.physician.mobile, streetName: x.physician.streetName, pincode: x.physician.pincode, department: x.physician.department.name, departmentID: x.physician.department.id },
              end_date: this.convertToDateType(endDate, x.endTime),
              start_date: this.convertToDateType(date, x.startTime),
              startTime: x.startTime,
              endTime: x.endTime,
              slot: x.timeSlotInMin,
              leave: false,
              // datas:x,
              slots: []
            }

            let dates = this.getDateArray(controlVal, endDate);
            for (let i = 0; i < dates.length; i++) {
              let ifAvailable = x?.dayOfWeek.split(",")?.filter(data => data == dates[i]?.day);
              slots.push(
                {
                  date: dates[i].date,
                  solt: [],
                  ifslot: ifAvailable.length > 0 ? true : false
                });

            }
            data.slots = [...slots];
            this.doctorLists.push(data);
          } else {
          }
        });
      });
    }

    if (this.docAvailsData != null && this.docAvailsData != undefined && this.docAvailsData.length > 0) {
      this.docAvailsData.forEach(x => {
        let controlVal: Date = (this.AptForm.controls['date'].value as Date);
        let date: Date = new Date(controlVal.getFullYear(), controlVal.getMonth(), controlVal.getDate());

        let ispresent = this.dateService.isBetween(date, new Date(x.fromDate), new Date(x.toDate));
        let sameDate = (date.getTime() === new Date(x.fromDate).getTime()
          || date.getTime() === new Date(x.toDate).getTime());
        if (ispresent || sameDate) {
          let endTime = this.convertToDateType(date, x.endTime);
          let startTime = this.convertToDateType(date, x.startTime);
          let ele = this.events.filter(y => {

            let timeValidation: boolean = ((this.dateService.isBetween(startTime, y.start_date, y.end_date)) && (this.dateService.isBetween(endTime, y.start_date, y.end_date))) ||
              ((y.start_date.getTime() == startTime.getTime()) || (this.dateService.isBetween(endTime, y.start_date, y.end_date))) ||
              ((y.end_date.getTime() == endTime.getTime()) || (this.dateService.isBetween(startTime, y.start_date, y.end_date))) ||
              ((y.end_date.getTime() == endTime.getTime()) && (y.start_date.getTime() == y.start_date.getTime())) ||
              ((y.start_date.getTime() > startTime.getTime()) && (y.end_date.getTime() < endTime.getTime()));
            return timeValidation;

          });
          if (ele !== null && ele !== undefined) {
            ele.forEach(i => {

              this.events.splice(this.events.findIndex(x => x.id == i.id), 1);
            });
          }
          if ((x.available as any) === "true") {
            this.events.push({
              id: x.id + date.getDay().toString(),
              end_date: this.convertToDateType(date, x.endTime),
              start_date: this.convertToDateType(date, x.startTime),
              slot: x.timeSlotInMin,
              leave: false
            });
          }
          else {
            this.leaveEvents.push({
              id: x.id + date.getDay().toString(),
              end_date: this.convertToDateType(date, x.endTime),
              start_date: this.convertToDateType(date, x.startTime),
              slot: x.timeSlotInMin,
              leave: true
            });
          }
        }

      });
    }
    this.createTimeChips(isEdit);
  }
  // get date
  getDateArray(start, end) {
    var arr = new Array();
    var dt = new Date(start);
    while (dt <= end) {
      arr.push({ date: new Date(dt), day: this.weekDays[dt.getDay()] });
      dt.setDate(dt.getDate() + 1);
    }

    return arr;
  }

  idDisabled(date: Date, doctorId) {
    if (this.bookedApts != null && this.bookedApts != undefined && this.bookedApts.length > 0) {
      var apts = this.bookedAptDates?.filter(d =>
        this.datePipe.transform(d.date, 'yyyy-MM-dd') == this.datePipe.transform(date, 'yyyy-MM-dd'))

      var data1 = apts?.filter(d => d?.date?.getTime() == date?.getTime());
      if (data1.length > 0) {
        if (data1[0]?.regID == this.paient_reg_id) {
          return { "disable": true, "yourApt": true };
        } else {
          return { "disable": true, "yourApt": false };
        }
      }
      else
        return { "disable": false, "yourApt": false };
    }

  }
  // diable AM PM booked
  onDisableBooked(date: Date, doctorId, apm, bookedCheck): any {
    if (apm) {

      return (this.getStartTime(date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()).toString()))

    } else {

      if (date.getTime() < new Date().getTime()) {
        return true;
      } else {
        return false;
      }

    }

  }

  // create a chip
  createTimeChips(isEdit: boolean): void {
    let doctorDataList = this.doctorLists
    for (var jj = 0; jj < doctorDataList.length; jj++) {
      var z = doctorDataList[jj];
      var startDate = z.start_date;
      // this.doctorLists.forEach(z => { 
      for (var i = 0; i < z.slots.length; i++) {
        let chips = [];
        let date: Date = startDate;
        var endDate = this.convertToDateType(date, z.endTime);

        while (date.getTime() < endDate.getTime()) {

          // for (var ii=0;ii<z.slots.length;ii++) {
          if (this.leaveEvents != null && this.leaveEvents != undefined && this.leaveEvents.length > 0) {
            this.leaveEvents.forEach(leave => {
              if (!(this.dateService.isBetween(date, leave.start_date, leave.end_date) && date.getTime() == leave.start_date.getTime())) {
                if (!this.onDisableBooked(date, z.doctor?.id, false, false)) {
                  chips.push(
                    {
                      "date": date,
                      time: this.onDisableBooked(date, z?.doctor?.id, true, false),
                      disabled: this.idDisabled(date, z?.doctor?.id),
                      duration: Number(z.slot)
                    });
                }
              }
            });
          }
          else {
            if (!this.onDisableBooked(date, z.doctor?.id, false, false)) {
              chips.push({
                "date": date,
                disabled: this.idDisabled(date, z?.doctor?.id),
                time: this.onDisableBooked(date, z?.doctor?.id, true, false), duration: Number(z.slot)
              });
            }
          }

          date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes() + z.slot, 0);
        }
        startDate = addDays(new Date(startDate), 1);
        doctorDataList[jj].slots[i].solt = z.slots[i].ifslot == true ? chips : [];
        chips = [];
      }

    }
    this.chips.sort((a, b) => 0 - (a.date.getTime() > b.date.getTime() ? -1 : 1));
    if (isEdit) {

    }

    this.doctorLists = this.removeDuplicates((doctorDataList), "doctorId")


  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  searchHospital(searchterm) {

  }
 
  loadDept(): void {
    this.deptSrvc.list(this.tenandId + '/' + "departments/" + this.branchId + '/' + this.paient_reg_id + '/getDepartmentByPatient').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.deptList = data.value;
    }, (error) => {
    }, () => {
    });
  }

  loadPhy(): void {
    this.phySrvc.list(`physicians/${this.tenandId}/${this.branchId}/${this.paient_reg_id}/GetPhysiciansByPatientAge`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.phyList = data.value;
      this.loadPhyList = this.phyList.slice(0);

    }, (error) => {
    }, () => {
    });
  }
  tConvert(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  // select Slot
  selectSlot(doctor, i) {
    this.doctorSlots = {
      doctor: doctor?.doctor,
      date: doctor?.slots[i].date,
      slots: doctor?.slots[i].solt
    };

    this.isDoctorSlot = true;
  }

  // select Slot
  downSlot(doctor, i) {
    if(this.p3 < (doctor?.slots[i].solt.length/10))
    {
      this.p3 = this.p3 + 1 
    } 
  }
  upSlot(doctor, i) { 
    if(this.p3>1)
    this.p3= this.p3 - 1
  }
  closeSlotDialog() {
    this.isDoctorSlot = false;
  }
  // var dt = moment("12:15 AM", ["h:mm A"]).format("HH:mm");
  dateWithOffset(val: Date): Date | null {
    let formControlValue = val;
    if (formControlValue !== null && formControlValue !== undefined) {
      let date: Date = new Date(this.datePipe.transform(formControlValue, 'mediumDate'));
      date.setMinutes(date.getMinutes() + Math.abs(date.getTimezoneOffset()));
      return date;
    }
    else {
      return null;
    }
  }
  get fval() { return this.AptForm.controls; }
  get fvalOtpForm() { return this.otpForm.controls; }


  visitTypeChange(event,type){
    this.selectedVisitType = type;

  }


  prevclicked() {
    if (this.p > 1)
      this.p = this.p - 1
  }
  nextclicked() {
    // if (this.p < (this.allTenent.length / 10)) {
    //   this.p = this.p + 1
    // }
    // else {
    //   let fDate: Date = null;
    //   let tDate: Date = null;
    //   if (this.searchterm == "" || this.searchterm == undefined) {

    //     this.searchterm = null;
    //   }
    //   this.skip = this.skip + 100;
    //   let searchData = {
    //     searchWord: this.searchterm,
    //     fromDate: fDate,
    //     toDate: tDate,
    //     skip: this.skip,
    //     take: this.take

    //   }
  


    // }
  }



  convertToDate(value: string): Date {
    let splitData = value.split(':');
    return new Date(new Date(Date.now()).getFullYear(), new Date(Date.now()).getMonth() - 1, new Date(Date.now()).getDate(), Number(splitData[0]), Number(splitData[1]), Number(splitData[2]));
  }

  convertToDateType(date: Date, value: string): Date {
    let splitData = value.split(':');

    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), Number(splitData[0]), Number(splitData[1]));
  }
  count1 = 0;
  onDisableBookedAM(date: Date, doctorId): string {
    this.count1++;
    let element: HTMLElement = document.getElementById(date.toString()).parentElement;
    if (date.getTime() < new Date().getTime()) {

      if (!(element.classList.contains("booked")))
        element.classList.add("booked");
    }
    this.bookedAptDates = [];
    this.bookedApts.forEach(apts => {
      apts.forEach(apt => {
        let aptdate: Date = new Date(apt.date);
        this.bookedAptDates.push(this.convertToDateType(aptdate, apt.slotTime.toString()));
      });
    });

    if (this.bookedApts != null && this.bookedApts != undefined && this.bookedApts.length > 0) {
      this.bookedAptDates.forEach(aptDate => {
        let elementOfAptDate: HTMLElement = document.getElementById(aptDate.toString());
        if (elementOfAptDate != null) {
          if (!(elementOfAptDate.parentElement.classList.contains("booked")))
            elementOfAptDate.parentElement.classList.add("booked");
        }
      });
    }

    if (this.patAptDates != null && this.patAptDates != undefined && this.patAptDates.length > 0) {
      this.patAptDates.forEach(aptDate => {
        let elementOfAptDate: HTMLElement = document.getElementById(aptDate.date.toString());
        if (elementOfAptDate != null && doctorId != aptDate.doctorId) {
          if (!(elementOfAptDate.parentElement.classList.contains("slot-booked"))) {
            elementOfAptDate.parentElement.classList.add("slot-booked");
            elementOfAptDate.parentElement.setAttribute("title", "Already Booked");
          }
        }
      });
    }

    // if (this.editSlotDate != null && this.editSlotDate != undefined && document.getElementById(this.editSlotDate.toString()) != null) {
    //   let element: HTMLElement = document.getElementById(this.editSlotDate.toString()).parentElement;
    //   if (!(element.classList.contains("selected"))) {
    //     element.classList.add("selected");
    //   }
    // }
    return (this.getStartTime(date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()).toString()))

    // return (date.getHours().toString() + "." + (date.getMinutes().toString().length == 1 ? (date.getMinutes().toString() + "0") : date.getMinutes().toString()) + " " + "AM");
  }
  onSelectApt(params: { args: any, slots: Date, status: string, duration: string, date: Date }, data, slot, i, dialogclose): void {

    let ele = params.args.target.tagName.toLocaleLowerCase() == "li" ? params.args.target : params.args.target.parentElement;

    var date = this.datePipe.transform(slot?.slots[i]?.date, 'yyyy-MM-dd');
    var time = this.datePipe.transform(params?.date, 'HH:mm');
    this.patientCreate = {
      tenantId: environment.dentaliaTenantId,
      branchId: environment.dentalidBranchId,
      doctorId: slot?.doctor?.id,
      regId: this.returnPatientRegId,
      createdDate: new Date(),
      cancellationDate: null,
      bookingstatusId: "Booked",
      actualStartTime: null,
      actualEndTime: null,
      bookingChannelId: 1,
      type: this.selectedVisitType,
      departmentId: slot?.doctor?.departmentID,
      date: this.dateWithOffset(slot?.slots[i]?.date),
      slotTime: date + "T" + time,
      duration: slot?.slot,
      templateId: this.templateMasterList[0]?.template_id,
      patientComplaints: [],
      "updatedDate": null,
      "createdBy": parseInt(localStorage.getItem("userId")),
      "updatedBy": null,
      "createdIP": null,
      "updatedIP": null,
      whenApptCharges:"Booked"

    };


    if (ele.classList.contains("selected")) {
      ele.classList.remove("selected");
    }
    var appoimentData = {
      date: slot?.slots[i]?.date,
      doctor: slot?.doctor,
      time: data.date,
      patientDetails: {
        name: this.patientData?.firstname,
        gender: this.patientData?.gender,
        age: this.patientData?.age,
        mobileno: this.patientData?.mobile,
        address: this.patientData?.city,
        email: this.patientData?.email,
        data: this.patientData
      },
    };
    this.appoimentDetails = appoimentData;
    if (dialogclose == true)
      this.isDoctorSlot = false
    this.isShowdialog = true;

  }
  goPayment() {
    this.isSubmitted = true;
    if (this.selectedVisitType != null && this.selectedVisitType != "")
      this.stepperComInst.next();
    else
      this.visitType = true;

    this.isSubmitted = false;
  }
  bookPatientAppointment() {
    
    this.appointmentBookingClickCount++;

    if(this.appointmentBookingClickCount==1){
      this.isSubmitted = true;
      this.patientCreate.type = this.selectedVisitType;
      this.patientCreate.bookingstatusId = "Booked";
      this.patientCreate.date =  new Date(this.patientCreate.slotTime);
      this.patientCreate.regId =  this.returnPatientRegId;
  
      this.IpOpCollectionReporsrvc.searchList("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId+'/createPatientAppointment', this.patientCreate).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  
        this.isSubmitted = false;
        this.appoimentDetails = null;
        this.isconfirmationMessage = true;
        this.resetAllAfterBookedAppt();
        
        setTimeout(() => {
          this.isconfirmationMessage = false;
        }, 4000);
        this.loadPastAppointments();
  
      }, (error) => {
      }, () => {
        this.isSubmitted = false;
      });
    }

  }
  onSuccess() {
    this.isShowdialog = false;
   // this.confirmAppoiment();
    // this.makePaymentVC();
  }
  onFailure() {
    this.patientEdit = null;
    this.patientCreate = null;
    this.isShowdialog = false;
  }
  CloseDialog() {
    this.patientEdit = null;
    this.patientCreate = null;
    this.isShowdialog = false;
    this.resetAllAfterBookedAppt();
  }

  resetAllAfterBookedAppt(){
    this.isShowdialog = false
    this.newUserPage=false;
    this.existinguserPage=false;
    this.returnPatientName=null;
    this.returnPatientAge=null;
    this.returnPatientMobile=null;
    this.returnPatientAddress=null;
    this.returnPatientGender=null;
    this.returnPatientTitle=null;
    this.returnPatientRegNumber=null;
    this.returnPatientRegId=null;
    this.registrationForm.reset();
    this.registrationClickCount=0;
    this.appointmentBookingClickCount=0;
    this.otpSentToCustomer=false;
    this.noPatientDataFoundBySearch=false;
    this.openOTPPage=false;
    this.thisPatientAreadyRegistered=false;
    this.EnterOtp=null;
   // this.otpForm.reset();
    this.registrationForm.reset();
   // this.AptForm.reset();
    this.otpForm.get('digit1').setValue(null);
    this.otpForm.get('digit2').setValue(null);
    this.otpForm.get('digit3').setValue(null);
    this.otpForm.get('digit4').setValue(null);
    this.otpForm.get('digit5').setValue(null);
    this.otpForm.get('digit6').setValue(null);
   // this.AptForm.get('date').setValue(new Date());

  }
  count = 0;
  onDisableBookedPM(date: Date, doctorId): string {
    this.count++;
    let element: HTMLElement = document.getElementById(date.toString()).parentElement;
    if (date.getTime() < new Date().getTime()) {

      if (!(element.classList.contains("booked")))
        element.classList.add("booked");
    }
    if (this.bookedApts != null && this.bookedApts != undefined && this.bookedApts.length > 0) {
      this.bookedAptDates.forEach(aptDate => {
        let elementOfAptDate: HTMLElement = document.getElementById(aptDate.toString());
        if (elementOfAptDate != null) {
          if (!(elementOfAptDate.parentElement.classList.contains("booked")))
            elementOfAptDate.parentElement.classList.add("booked");
        }
      });
    }

    if (this.patAptDates != null && this.patAptDates != undefined && this.patAptDates.length > 0) {

      this.patAptDates.forEach(aptDate => {
        let elementOfAptDate: HTMLElement = document.getElementById(aptDate.date.toString());
        if (elementOfAptDate != null && doctorId != aptDate.doctorId) {
          if (!(elementOfAptDate.parentElement.classList.contains("slot-booked"))) {
            elementOfAptDate.parentElement.classList.add("slot-booked");
            elementOfAptDate.parentElement.setAttribute("title", "Already Booked");
          }
        }
      });
    }

    //
    return (this.getStartTime(date.getHours() + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()).toString()))
    // return ((date.getHours() - 12 === 0 ? 12 : date.getHours() - 12).toString() + "." + (date.getMinutes().toString().length == 1 ? (date.getMinutes().toString() + "0") : date.getMinutes().toString()) + " " + "PM");
  }
  convertToTimeSpan(value: Date): any {

    let date: Date = new Date(value.getFullYear(), value.getMonth() - 1, value.getDate(), value.getHours(), 0);
    date.setMinutes(value.getMinutes() + Math.abs(new Date(Date.now()).getTimezoneOffset()));
    //let utcDate: Date = new Date(value.getUTCFullYear(),value.getUTCMonth()-1,value.getUTCDate(),value.getUTCHours(),value.getUTCMinutes());
    return date;
  }

  newUser(){
    
    this.isShowdialog=false;
    this.newUserPage=true;
    this.existinguserPage=false;

  }

  closeOtpPopupPage(){
    this.newUserPage=true;
    this.isShowdialog=false;
    this.existinguserPage=false;
    this.openOTPPage=false;
  }
  existingUser(){
    this.newUserPage=false;
    this.isShowdialog=false;
    this.existinguserPage=true;
  }
  closeNewUserPage(){
   this.isShowdialog=true;
    this.newUserPage=false;
    this.existinguserPage=false;
    // this.returnPatientName=null;
    // this.returnPatientAge=null;
    // this.returnPatientMobile=null;
    // this.returnPatientAddress=null;
    // this.returnPatientGender=null;
    // this.returnPatientTitle=null;
    // this.returnPatientRegNumber=null;
    // this.returnPatientRegId=null;

    // this.registrationForm.get('address').setValue(null)
    // this.registrationForm.get('mobileNumber').setValue(null)
    // this.registrationForm.get('gender').setValue(null)
    // this.registrationForm.get('age').setValue(null)
    // this.registrationForm.get('title').setValue(null)
    // this.registrationForm.get('ageResult').setValue(null)
    // this.registrationForm.get('firstName').setValue(null)
  }

  closeExistingUserPage(){
    this.isShowdialog=true;
    this.newUserPage=false;
    this.existinguserPage=false;
  }
  getStartTime(input): string {

    var startDisplayTime;
    var endDisplayTime;
    if (input != null || input !== "") {
      startDisplayTime = input.split(':');
      var ampmStart = (startDisplayTime[0] >= 12 ? ' PM' : ' AM');
      startDisplayTime[0] = startDisplayTime[0] % 12;
      startDisplayTime[0] = (startDisplayTime[0] == 0 ? 12 : startDisplayTime[0]);
      startDisplayTime = startDisplayTime.join(':') + ampmStart;
      endDisplayTime = startDisplayTime;
    }

    else {
      endDisplayTime = ""

    }

    return endDisplayTime;
  }
  getTemplateId() {

    let index = (this.commList as Array<any>).findIndex(x => x.key == "appointment");
    this.templateMasterList = (this.commList[index].type as Array<any>);

  }

  onTitleChange(event: INgxSelectOption[]) {

    if(event.length>0){
      if (event[0].data.value == "1" || event[0].data.value == "5") {
        this.registrationForm.controls['gender'].setValue("Male");
      }
      else if (event[0].data.value == "2" || event[0].data.value == "3" || event[0].data.value == "4") {
        this.registrationForm.controls['gender'].setValue("Female");
      }
    }
  
  }
  searchRegisteredPatient(){
    this.searchExistingPatientSubmitted=true;
    if(this.registrationForm.controls['searchPatientReg'].valid && 
    this.registrationForm.controls['searchPatientMobile'].valid){
    if(this.registrationForm.controls['searchPatientReg'].value != null &&
    this.registrationForm.controls['searchPatientReg'].value != undefined && 
    this.registrationForm.controls['searchPatientReg'].value != "" && 
    (this.registrationForm.controls['searchPatientMobile'].value == null ||
    this.registrationForm.controls['searchPatientMobile'].value == undefined || 
    this.registrationForm.controls['searchPatientMobile'].value == "")  ){
    this.regIdOnChange();
    this.chooseAnyOneFilter=false;
    this.searchExistingPatientSubmitted=false;

    }
    else if(this.registrationForm.controls['searchPatientMobile'].value != null &&
    this.registrationForm.controls['searchPatientMobile'].value != undefined && 
    this.registrationForm.controls['searchPatientMobile'].value != "" && 
    (this.registrationForm.controls['searchPatientReg'].value == null ||
    this.registrationForm.controls['searchPatientReg'].value == undefined || 
    this.registrationForm.controls['searchPatientReg'].value == "")  ){
    this.checkIfMobileNoExist();
    this.chooseAnyOneFilter=false;
    this.searchExistingPatientSubmitted=false;

    }
    else{
      this.chooseAnyOneFilter=true;
    }
  }
  }
  regIdOnChange() {
   
    if (this.registrationForm.controls["searchPatientReg"].valid) {
           
        let regNumberValue=this.registrationForm.controls['searchPatientReg'].value;
     
       
        this.chiefComplSrvc.list("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId + '/filterByPatientRegNumber/'+regNumberValue).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {


if(data!=null){
  this.noPatientDataFoundBySearch=false;

         this.returnPatientName=data.firstname;
          this.returnPatientAge=data.age;
          this.returnPatientMobile=data.mobile;
          this.returnPatientAddress=data.address1;
          this.returnPatientGender=data.gender;
          this.returnPatientTitle=data.title;
          this.returnPatientRegNumber=data.regNum;
          this.returnPatientRegId=data.id;

}else{
  this.returnPatientName=null;
  this.returnPatientAge=null;
  this.returnPatientMobile=null;
  this.returnPatientAddress=null;
  this.returnPatientGender=null;
  this.returnPatientTitle=null;
  this.returnPatientRegNumber=null;
  this.returnPatientRegId=null;
  this.noPatientDataFoundBySearch=true;
}
        
            
            
                }, (error) => {
            
                }, () => {
            
                });
      
    }

  
}

getPatientTitle(data){
return this.titleList.find(e=>e.value==data).title;

}


checkPatientIsExistsForOTP(){

  if(this.registrationForm.valid){
    this.chiefComplSrvc.list("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId + '/validatePatientExists/'+this.registrationForm.get('mobileNumber').value
    +'/'+this.registrationForm.get('firstName').value +'/'+this.registrationForm.get('gender').value).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      if(data==null){
           this.openOTPPage=true; 
           this.newUserPage=false;   
           this.sendOtp();
      } else{
      this.thisPatientAreadyRegistered=true;


      }
      this.FillMandatoryFieldsRegistration=false;

    }, (error) => {
  
    }, () => {
  
    });
  }else{
    this.FillMandatoryFieldsRegistration=true;
  }


}


  checkIfMobileNoExist(){

    if (this.registrationForm.controls["searchPatientMobile"].valid) {
          
  let mobileNmber=this.registrationForm.controls['searchPatientMobile'].value;
      this.chiefComplSrvc.list("iFrameAppointmentController/" + this.tenandId + '/' + this.branchId + '/filterByPatientMobile/'+mobileNmber).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

        if(data!=null){
                   this.returnPatientName=data.firstname;
                  this.returnPatientAge=data.age;
                  this.returnPatientMobile=data.mobile;
                  this.returnPatientAddress=data.address1;
                  this.returnPatientGender=data.gender;
                  this.returnPatientTitle=data.title;
                  this.returnPatientRegNumber=data.regNum;
                  this.returnPatientRegId=data.id;
                  this.noPatientDataFoundBySearch=false;


        }  else{
          this.returnPatientName=null;
          this.returnPatientAge=null;
          this.returnPatientMobile=null;
          this.returnPatientAddress=null;
          this.returnPatientGender=null;
          this.returnPatientTitle=null;
          this.returnPatientRegNumber=null;
          this.returnPatientRegId=null;
          this.noPatientDataFoundBySearch=true;

        }
  
      }, (error) => {
  
      }, () => {
  
      });
      
    
    
    }
   
}
  onGenerateHashKey() {

    var text = this.key + "|" + this.txnid + "|" + this.amount + "|" +
      this.productinfo + "|" + this.firstname + "|" + this.email + "|" + this.udf1 + "|" + this.udf2 + "|" + this.udf3 + "|" + this.udf4 + "|" + this.udf5 + "||||||" + this.salt;
    this.hash = sha512.sha512(text);

  }

  makePaymentVC() {


    this.onlinePaystart = true;
    this.onGenerateHashKey();
    
    var winName = 'Payment Screen';
    var winURL = this.url;
    // var windowoption ='resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';
    var params = {
      key: this.key,
      txnid: this.txnid,
      amount: this.amount,
      firstname: this.firstname,
      email: this.email,
      phone: this.phone,
      productinfo: this.productinfo,
      surl: this.surl,
      furl: this.furl,
      curl: this.curl,
      udf1: this.udf1,
      udf2: this.udf2,
      udf3: this.udf3,
      udf4: this.udf4,
      udf5: this.udf5,
      hash: this.hash,
    };

    var data = {
      status: true,
      data: params,
      appoimentDetails: this.appoimentDetails,
      start: new Date(),
      end: null,
      url:this.url,
      salt:this.salt
    };
    window.localStorage.setItem("onliePayment", JSON.stringify(data));
    window.sessionStorage.setItem("onliePayment", JSON.stringify(data));
    this.cookieService.set("onliePayment", JSON.stringify(data));

    var form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', winURL);
    form.setAttribute('target', winName);
    for (var i in params) {
      if (params.hasOwnProperty(i)) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
      }
    }
    document.body.appendChild(form);
    let popupWin = window.open('', '_blank', winName);
    form.target = winName;
    form.submit();
    document.body.removeChild(form);
    popupWin.close();
    var loop = setInterval(function () {
      if (popupWin.closed) {
        clearInterval(loop);
        // this.this.onlinePaystart = false;
      }
    }, 1000);
  }
  checkOnliePaymentPendint(){
    this.lastPaymentData=JSON.parse(window.localStorage.getItem("onliePayment"));
    if(this.lastPaymentData?.status){
      this.appoimentDetails = this.lastPaymentData?.appoimentDetails;
      this.lastPayment=true;
    }else{
      this.lastPaymentData=JSON.parse(window.sessionStorage.getItem("onliePayment"));
      if(this.lastPaymentData?.status){
        this.appoimentDetails = this.lastPaymentData?.appoimentDetails;
        this.lastPayment=true;
      }else{
        if(this.cookieService.get('onliePayment')){
          this.lastPaymentData=JSON.parse(this.cookieService.get('onliePayment'));
        }
        if(this.lastPaymentData?.status){
          this.appoimentDetails = this.lastPaymentData?.appoimentDetails;
          this.lastPayment=true;
        }else{
           this.lastPayment=false;
        }
      }
    }
    
  }

  retryApt() {


    this.key = this.lastPaymentData?.data?.key;
    this.txnid = this.lastPaymentData?.data?.txnid;
    this.amount = this.lastPaymentData?.data?.amount;
    this.firstname = this.lastPaymentData?.data?.firstname;
    this.email = this.lastPaymentData?.data?.email;
    this.phone = this.lastPaymentData?.data?.phone;
    this.productinfo = this.lastPaymentData?.data?.productinfo;
    this.regID = localStorage.getItem("regID");
    this.resurl = this.lastPaymentData?.data?.surl;
    this.url = this.lastPaymentData?.url;
    this.surl = this.resurl
    this.furl = this.resurl
    this.curl = this.resurl
    this.udf1 = this.lastPaymentData?.data?.udf1;
    this.udf2 = this.lastPaymentData?.data?.udf2;
    this.udf3 = this.regID;
    this.udf4 = this.lastPaymentData?.data?.udf4;
    this.udf5 = this.lastPaymentData?.data?.udf5;

    this.hash = this.lastPaymentData?.data?.hash;
    this.salt = this.lastPaymentData?.salt;
    this.appoimentDetails = this.lastPaymentData?.appoimentDetails;
    this.makePaymentVC();
  }
  cancelretryApt() {

  }
  closeretryApt() {
    this.lastPayment = false;
    // this.lastPaymentData=null;
    this.appoimentDetails = null;
  }

  makeAppointmentold() {

    const baseUri: string = 'https://test.payu.in/_payment';
    var postApi = {
      "key": "JPM7Fg",
      "txnid": "qSsEfAnFP4qNRS",
      "amount": "10.00",
      "firstname": "Ashish",
      "email": "test@gmail.com",
      "phone": "9876543210",
      "productinfo": "iPhone",
      "pg": "cc",
      "bankcode": "cc",
      "surl": "https://apiplayground-response.herokuapp.com/",
      "furl": "https://apiplayground-response.herokuapp.com/",
      "ccnum": "5123456789012346",
      "ccexpmon": "05",
      "ccexpyr": "2022",
      "ccvv": "123",
      "ccname": "undefined",
      "hash": "fc7a7cb2cfee5edc3aaf6f24dd7ba180c691c2a1e44e9d16a1815d58c992896451852444de74da291812569477cccaf5ebecc3893f1978aa76cfc651ffb9d3f4"
    }
    let header = new HttpHeaders();
    header.append("Content-Type", "application/x-www-form-urlencoded");
    header.append("accept", "application/json");

    const formData: FormData = new FormData();
    for (const prop in postApi) {
      if (!postApi.hasOwnProperty(prop)) { continue; }
      formData.append(prop, postApi[prop]);
    }

  }
  // apiCall(url,data,header)  { 
  //   return this.http.post(url, data, {headers: header});
  //  }
}

interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
} 

